export function initializeSupport(scope = document) {
  scope.querySelectorAll('[data-qvb-contact]').forEach((root) => {
    if (root.dataset.qvbReady) return;
    const select = root.querySelector('[data-qvb-topic-field]');
    if (!select) return;
    const controller = new AbortController();
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-qvb-topic]');
      if (!link) return;
      const value = link.dataset.qvbTopic;
      if ([...select.options].some((option) => option.value === value)) {
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, { signal: controller.signal });
    root.dataset.qvbReady = 'true';
    root.qvbCleanup = () => controller.abort();
  });
}
if (typeof document !== 'undefined') {
  initializeSupport();
  document.addEventListener('shopify:section:load', (event) => initializeSupport(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-qvb-contact]').forEach((root) => root.qvbCleanup?.());
  });
}
